import { useEffect, useState } from 'react';
import { authedImageUrl, getToken } from '../api/client';

interface Props {
  src: string;
  alt?: string;
  className?: string;
}

export default function AuthedImage({ src, alt, className }: Props) {
  const [url, setUrl] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [isPdf, setIsPdf] = useState(false);

  useEffect(() => {
    let active = true;
    let blobUrl: string | null = null;
    const token = getToken();
    fetch(authedImageUrl(src), { headers: token ? { Authorization: `Bearer ${token}` } : {} })
      .then(async (res) => {
        if (!res.ok) throw new Error('Görsel yüklenemedi');
        const blob = await res.blob();
        if (!active) return;
        blobUrl = URL.createObjectURL(blob);
        setIsPdf(blob.type === 'application/pdf');
        setUrl(blobUrl);
      })
      .catch((err) => active && setError(err.message));
    return () => {
      active = false;
      if (blobUrl) URL.revokeObjectURL(blobUrl);
    };
  }, [src]);

  if (error) return <div className="text-sm text-red-600">{error}</div>;
  if (!url) return <div className="text-sm text-slate-500">Yükleniyor…</div>;
  if (isPdf) {
    return (
      <object data={url} type="application/pdf" className={className ?? 'w-full h-[600px]'}>
        <a href={url} target="_blank" rel="noreferrer">PDF'i aç</a>
      </object>
    );
  }
  return <img src={url} alt={alt ?? 'Fiş görseli'} className={className} />;
}
